import { createAction, props } from '@ngrx/store';
import {TenantRole} from "../../models/tenant-role.model";

export const getUsersRoleAndTenantData = createAction(
  '[App Component] Get UsersRoleAndTenantData',
  props<{ tenantId: string, roleId: string }>()

);

export const getUsersRoleAndTenantDataSuccess = createAction(
  '[TenantRole Service] Get UsersRoleAndTenantData Success',
  props<{ tenantRoleData: TenantRole }>()

);

export const getUsersRoleAndTenantDataFailure = createAction(
  '[TenantRole Service] Get UsersRoleAndTenantData Failure',
  props<{ error: any }>()
);


